import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AnalyticsService, DashboardStats, PropertyTypeStats, ListingTypeStats, MessageStats } from '../../../services/analytics.service';

@Component({
  selector: 'app-analytics',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './analytics.component.html',
  styleUrl: './analytics.component.css'
})
export class AnalyticsComponent implements OnInit {
  stats = signal<DashboardStats | null>(null);
  propertyTypeStats = signal<PropertyTypeStats[]>([]);
  listingTypeStats = signal<ListingTypeStats[]>([]);
  messageTrends = signal<MessageStats[]>([]);
  averageResponseTime = signal<number>(0);
  loadingStats = signal(true);
  loadingCharts = signal(true);

  constructor(
    private analyticsService: AnalyticsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadAllAnalytics();
  }

  private async loadAllAnalytics() {
    try {
      // Load main stats
      this.loadingStats.set(true);
      const statsData = await this.analyticsService.getDashboardStats();
      this.stats.set(statsData);
      this.loadingStats.set(false);

      // Load additional analytics
      this.loadingCharts.set(true);
      const [propTypes, listTypes, trends, avgResponse] = await Promise.all([
        this.analyticsService.getPropertyTypeStats(),
        this.analyticsService.getListingTypeStats(),
        this.analyticsService.getMessageTrends(),
        this.analyticsService.getAverageResponseTime()
      ]);

      this.propertyTypeStats.set(propTypes);
      this.listingTypeStats.set(listTypes);
      this.messageTrends.set(trends);
      this.averageResponseTime.set(avgResponse);
    } catch (error) {
      console.error('Error loading analytics:', error);
    } finally {
      this.loadingCharts.set(false);
    }
  }

  goBack() {
    this.router.navigate(['/admin']);
  }

  getMaxMessageCount(): number {
    const counts = this.messageTrends().map(m => m.count);
    return counts.length > 0 ? Math.max(...counts) : 1;
  }

  getBarHeight(count: number): number {
    const max = this.getMaxMessageCount();
    return max > 0 ? (count / max) * 100 : 0;
  }

  formatDate(dateStr: string): string {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
}
